import React, { Component } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Only from "react-only-when";
import { RoomBody } from "./";
import { IcoMoon, Ribbon } from "../../../common";
import { getPropertyItemTitle } from "../../../../helpers/general-helpers";
import styles from "./styles.less";

class Room extends Component {
  onRemoveClick = addonCode => {
    const { onAddonRemove, pax } = this.props;
    onAddonRemove && onAddonRemove(pax.id, addonCode);
  };

  render() {
    const {
      id,
      isPackage,
      name,
      roomName,
      planName,
      pax,
      titles,
      isRtl,
      roomId,
      rateId,
      selectedAddons,
      propertyType,
      className
    } = this.props;

    return (
      <div className={cx(styles.room, className, { [styles.rtl]: isRtl })}>
        <Only when={isPackage}>
          <Ribbon
            shape="horizontal"
            isRtl={isRtl}
            wrapperClassName={cx(styles.ribbonWrapper, { [styles.rtl]: isRtl })}
            textClassName={styles.ribbonInner}
            text={titles.SpecialDeal}
          />
        </Only>

        <div className={styles.roomNumber}>
          <IcoMoon name="double-king-size-bed" />
          <div className={styles.title}>
            {`${getPropertyItemTitle(titles, propertyType)} ${name}`}:
          </div>
        </div>

        <RoomBody
          id={id}
          className={styles.roomBody}
          isRtl={isRtl}
          roomName={roomName}
          planName={planName}
          titles={titles}
          pax={pax}
          roomId={roomId}
          rateId={rateId}
          selectedAddons={selectedAddons}
          onAddonRemove={this.onRemoveClick}
        />
      </div>
    );
  }
}

Room.defaultProps = {
  roomName: "",
  planName: ""
};

Room.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  roomName: PropTypes.string,
  roomId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  planName: PropTypes.string,
  isPackage: PropTypes.bool,
  isRtl: PropTypes.bool,
  //clubUserLoggedIn: PropTypes.bool,
  pax: PropTypes.object,
  selectedAddons: PropTypes.array,
  titles: PropTypes.object,
  className: PropTypes.string,
  propertyType: PropTypes.string,
  onAddonRemove: PropTypes.func
};

export default Room;



// WEBPACK FOOTER //
// ./src/components/Cart/Rooms/Room/Room.js